/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_PAYMENT_STATUS } from "../graphql";
import { VApplication } from "../../../application";
import { usePolicyId } from "../provider";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdatePaymentMethods extends IPluginMethodMap {
  getUpdatePayment(args: any): Promise<any>;
}

export interface UpdatePaymentProps {
  paymentStatus: string;
  amount: string;
  comment: string;
  receipt?: any;
}

export class UpdatePaymentService implements IAgentPlugin {
  readonly methods: IUpdatePaymentMethods;
  constructor() {
    this.methods = {
      getUpdatePayment: this.getUpdatePayment.bind(this),
    };
  }

  async getUpdatePayment(args: UpdatePaymentProps) {
    console.log(`payment update inside mutation`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_PAYMENT_STATUS,
          variables: {
            input: {
              ...args,
              paymentStatus: "FULLY_PAID",
              amount: parseFloat(args?.amount),
              receipt: Array.isArray(args?.receipt)
                ? args?.receipt[0]?.base64
                : null,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return res?.data?.updatePaymentStatus;
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
